/**
 * Capacitor plugin that allows users to submit app store reviews and ratings
 * Reference docs used to derive types & behavior:
 *   https://www.npmjs.com/package/@capawesome/capacitor-app-review
 */

import { CapacitorPluginsBase } from "./capacitorPluginsBase";

class InAppReview extends CapacitorPluginsBase {
  requestReview () {
    this.plugins.InAppReview.requestReview();
  }
}

export default new InAppReview();